module.exports = __webpack_public_path__ + "assets/img/Small.e09a81ad.svg";